import { Componente } from 'src/components/componentes/types';
import { ComponenteEstrutura, InversorModuloResponse, PosicaoModulo, ProjetoCalcular, ProjetoTipoType, SegmentoType, TipoProposta } from "src/components/projetos/types";
import { removeServicoCamposProjeto } from "src/components/projetos/utils/removeServicoCamposProjeto";
import api, { apiNoLoading, IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import AProvider from "src/framework/providers/AProvider";
import { notifierStore } from 'src/framework/store/NotifierStore';
import { calculoProjetoRealizado$ } from 'src/store/vendas/projetos/store';

export interface RequestEnviarPagamento {
    codigo_venda: string;
    nota_fiscal_triangular: boolean;
    tipo_proposta_envio: string;
}

interface CapturarRequest {
    cpfCnpjDistribuidor: string;
    cpfCnpjRevenda?: string
    tipo?: ProjetoTipoType;
    segmento?: SegmentoType;
    potencia?: number;
    engenharia?: boolean;
    codigo_venda?: string;
    hibrido?: boolean;
}

interface CalcularPotenciaRequest {
    latitude: number;
    longitude: number;
    fator_perda: number;
    consumo_meses: number[]
}

interface CalcularPotenciaResponse {
    potencia: number;
}

interface QuantidadeDeModulosResponse {
    quantidade: number;
}

interface CalcularInversoresBodyRequest {
    categoria_componentes_id?: number;
    inversor_tensao: number;
    inversor_tipo_conexao: number;
    inversor_modelo?: string;
    modelo_inversor?: string;
    total_modulos: number;
    potencia: number,
    regioes: number[];
    segmento: string;
}

interface InversoresCalculadosResponse extends InversorModuloResponse {
    quantidade: number;
}

interface CalcularInversoresBodyResponse {
    inversores: InversoresCalculadosResponse[];
    modulos_restantes: number;
}
interface ListarInversoresBodyResponse {
    inversores: InversoresCalculadosResponse[];
}

interface FileiraRequest {
    posicao: PosicaoModulo;
    estrutura_id: number;
    modulos_sequencia: number,
    fileiras_iguais: number
}

export interface CalcularEstruturaRequest {
    potencia: number;
    inversor: string;
    regiao_id: string[];
    fileiras: FileiraRequest[];
    segmento: string;
    inversores?: {
        id: number;
        quantidade: number;
        categoria_componentes_id: number;
    }[]
    controladores?: {
        id: number;
        quantidade: number;
        categoria_componentes_id: number;
    }[]
}

export interface CalcularAcessoriosRequest {
    regiao_id: number[];
    quantidade_modulos?: number;
    segmento?: 'on' | 'off';
    inversores?: {
        id: number;
        quantidade: number;
        categoria_componentes_id: number;
    }[];
    controladores?: {
        id: number;
        quantidade: number;
        categoria_componentes_id: number;
    }[]
}

export interface CalcularCorrenteReversaRequest {
    inversores: number[]
}

export interface CalculoCorrenteReversaResponse {
    corrente_reversa: boolean;
    inversores: number[]
}

export interface CalcularModulosStringRequest {
    tipo: string,
    segmento: string,
    quantidade_modulos: number,
    inversores: {
        id: number;
        quantidade: number;
    }[]
}

export interface CalculoModulosStringResponse {
    divergencia_strings: boolean;
}

export interface CalcularEstruturaResponse extends ComponenteEstrutura {
    quantidade: number;
    quantidade_item: number;
    quantidade_modulos: number;
    descricao_componente: string;
}

export interface CalculoComponenteResponse extends Pick<Componente, 'id' | 'categoria_componentes_id' | 'modelo' | 'nome' | 'descricao' | 'peso' | 'tempo_garantia' | 'tempo_garantia_unidade' | 'considerar_calculo' | 'exibir_listagem' | 'comprimento' | 'largura' | 'altura' | 'created_at' | 'updated_at'> {
    nome_componente: string;
    descricao_componente: string;
    segmento: string;
    venda: string;
    stringbox_saidas: number;
    stringbox_entradas: number;
    quantidade: number;
    atributos?: any[];
    regra_indicacao?: any[];
}

interface CalcularRoiPaybackDadosResponse {
    ano: number
    rendimento: number
    geracao_anual_energia_kwh: number
    consumo_anual_kwh: number
    geracao_menos_consumo: number
    reajuste_medio_anual_de_energia_descontada_inflacao: number
    custo_kwh: number
    consumo_considerando_simultaneidade: number
    economia_gerada: number
    economia_acumulada: number
    retorno_investimento: number      
}

export interface CalcularPaybackRoiProps {
    consumos: { dia: string; consumo: number }[]
    fatorPerdas: number
    latitude: number
    longitude: number
    moduloId: number
    potenciaGerador: number
    simultaneidade: number
    valorProjeto: number
    estadoId: string
    tarifaConcessionariaId: number
    dataProjeto: Date | string
    recalcular: boolean
    idProjeto?: number
}

interface CalcularRoiPaybackResponse {
    dados: CalcularRoiPaybackDadosResponse[]
    geracao_mensal: {
        [index: string]: number;
    };
    consumo: {
        [index: string]: number;
    };
    geracao_total: number;
}

interface CalcularRoiPaybackRequest {
    projetoId?: number;
    calculateData?: CalcularPaybackRoiProps

}

interface CarrinhoKitItensResponse {
    id: number| null;
    nome: string;
    segmento: string;
    tipo: string;
    valor?: number | null;
    quantidade: number;
    comissao_distribuidor?: number | null;
    fator?: number | null;
    user_guilted_id?: number | null;
    created_at?: string;
    updated_at?: string | null;
}
export interface CarrinhoKitsResponse {
    id: number| null;
    guid: string;
    codigo_venda?: string | null;
    observacao?: string | null;
    user_guilted_id?: number | null;
    created_at?: string;
    updated_at?: string | null;
    itens: CarrinhoKitItensResponse[]
}

class ProjetosProvider extends AProvider {
    constructor() {
        super("/projetos");
    }

    async registrarEnvioPropostaWhatsapp(idProjeto: number, origem: "modal-detalhes" | "menu-acoes", apiInstance = apiNoLoading) {
        if (!idProjeto) return;
        if (!origem) return;
        
        const request: IDataRequest = {
            url: `${this.path}/proposta/whatsapp`,
            data: {
                projeto_id: idProjeto,
                origem,
            }
        }

        await apiInstance.post(request);
    }

    async capturar({ cpfCnpjDistribuidor, cpfCnpjRevenda, tipo, segmento, potencia, engenharia, codigo_venda, hibrido }: CapturarRequest, apiInstance = api): Promise<any> {
        try {

            const dataRequest: any = { cnpj_cpf_distribuidor: cpfCnpjDistribuidor, tipo, segmento };

            if (cpfCnpjRevenda) {
                dataRequest["cnpj_cpf_revenda"] = cpfCnpjRevenda
            }

            if (potencia) {
                dataRequest["potencia"] = potencia
            }

            if (engenharia) {
                dataRequest["engenharia"] = engenharia
            }

            if (codigo_venda) {
                dataRequest["codigo_venda"] = codigo_venda
            }

            if (hibrido) {
                dataRequest["hibrido"] = hibrido
            }

            const request: IDataRequest = {
                url: `${this.path}/capturar`,
                data: dataRequest
            }

            const response: IDataResponse = await apiInstance.post(request);

            if (response.statusCode === STATUS_CODE.OK) {
                return response.data
            }

            return { error: `Não foi possível capturar um código de venda.${cpfCnpjDistribuidor === '' ? " Selecione pelo menos o distribuidor." : ''}` }
        } catch (error) {
            return { error: "Não foi possível capturar um código de venda" }
        }
    }

    async saveRevisaoProjeto(projeto: any): Promise<IDataResponse> {
        const data = {
            etapa_venda: "sla_engenharia",
            revisoes: projeto.revisoes
        }

        if (projeto?.remove_servico) {
            Object.assign(data, removeServicoCamposProjeto(data))
        }

        const response = await this.save(projeto.id, data)

        return response;
    }

    async cancelar(projetos: string[]): Promise<IDataResponse> {
        try {
            const request: IDataRequest = {
                url: "/projetos/cancelar",
                data: {
                    projetos: projetos
                }
            }

            return await api.post(request);
        } catch (error) {
            return {
                data: null,
                message: "Erro ao cancelar projeto(s)",
                statusCode: 404
            }
        }
    }

    async calcular(projeto: ProjetoCalcular, noLoading?: boolean): Promise<IDataResponse> {
        try {
            const request: IDataRequest = {
                url: "/projetos/calcular",
                data: projeto
            }

            let response: IDataResponse;
            if(!noLoading) {
                response = await api.post(request);
            }

            response = await apiNoLoading.post(request);
            if (response.statusCode !== STATUS_CODE.OK) {
                notifierStore.setNotifier({
                    content: "Não foi possível calcular os valores do projeto. Verifique os dados informados e tente novamente.",
                    title: "Atenção!",
                    timeOut: 3000,
                    onClose: () => notifierStore.setOpen(false),
                });
                notifierStore.setOpen(true);

                calculoProjetoRealizado$.next(false);
                return response;
            }

            calculoProjetoRealizado$.next(true);
            return response;
        } catch (error) {
            calculoProjetoRealizado$.next(false);
            return {
                data: null,
                message: "Erro ao efetuar o cálculo",
                statusCode: 404
            }
        }

    }

    unificarComponentes = (componentes: any[], getId: (item: any) => number): any[] => {
        return Array.from(
            componentes?.reduce((map: Map<number, any>, item) => {
                const id = getId(item);
                const existente = map.get(id);

                if (existente) {
                    existente.quantidade += item.quantidade || 0;
                } else {
                    map.set(id, { ...item });
                }

                return map;
            }, new Map<number, Componente>()).values()
        );
    };

    confereRecalcular(componentesAEnviar: any[], projeto: any) {
        if (projeto?.recalcular || projeto?.alterou_segmento) {
            return true;
        }
         
        let recalcular = false;
        const componentesAnteriores = projeto?.old_componentes_edicao || [];
        const componentesAEnviarUnificados = this.unificarComponentes(componentesAEnviar, item => item.componente_id) || [];
        const componentesAnterioresUnificados = this.unificarComponentes(componentesAnteriores, item => item.id) || [];

        if (componentesAnterioresUnificados?.length) {
            for (const item of componentesAnterioresUnificados) {
                const componente = componentesAEnviarUnificados.find(c => c.componente_id === item.id);
                if (componente) {
                    if (componente.quantidade !== item.quantidade) {
                        recalcular = true;
                    }
                } else {
                    recalcular = true;
                }
            }
            if (!recalcular) {
                // && componentesAnteriores && componentesAEnviar.length !== componentesAnteriores.length
                for (const item of componentesAEnviarUnificados) {
                    const componente = componentesAnterioresUnificados.find((c: { id: any; }) => c?.id === item.componente_id);
                    if (!componente) {
                        recalcular = true;
                    }
                } 
            }
        }

        if (!recalcular && ((projeto.estado_id && projeto.estado_id !== projeto.old_estado_id) || !componentesAnteriores?.length)) {
            recalcular = true;
        }
        
        return recalcular;
    }

    async downloadAnexos(id: number): Promise<IDataResponse> {
        try {
            const request: IDataRequest = {
                url: `/projetos/anexos/zip/${id}`,
            }

            return await api.getFile(request);
        } catch (error) {
            return {
                data: null,
                message: "Erro ao efetuar o download de anexos",
                statusCode: 404
            }
        }
    }

    async calcularPotencia(payload: CalcularPotenciaRequest): Promise<IDataResponse<CalcularPotenciaResponse>> {
        try {
            const request: IDataRequest = {
                url: `/projetos/potencia/calcular`,
                data: payload
            }

            return api.post(request);
        } catch (error) {
            return {
                data: { potencia: 0 },
                message: "Erro ao efetuar calculo",
                statusCode: 404
            }
        }
    }

    async buscarQuantidadeDeModulos(moduloId: number, potencia: number, segmento: string, apiInstance = api): Promise<IDataResponse<QuantidadeDeModulosResponse>> {
        const segmentoLocal = segmento.includes("on") ? "on" : "off"

        try {
            const request: IDataRequest = {
                url: `/projetos/modulos/${moduloId}/${potencia}?segmento=${segmentoLocal}`,
            }
            return apiInstance.get(request);
        } catch (error) {
            return {
                data: { quantidade: 0 },
                message: "Erro ao efetuar calculo",
                statusCode: 404
            }
        }
    }

    async calcularInversores(moduloId: number, body: CalcularInversoresBodyRequest): Promise<IDataResponse<CalcularInversoresBodyResponse>> {
        try {
            const request: IDataRequest = {
                url: `/projetos/inversores/${moduloId}/calcular`,
                data: body,
            }
            return api.post(request);
        } catch (error) {
            return {
                data: { inversores: [], modulos_restantes: 0 },
                message: "Erro ao efetuar calculo",
                statusCode: 404
            }
        }
    }

    async listarInversores(moduloId: number, body: CalcularInversoresBodyRequest): Promise<IDataResponse<ListarInversoresBodyResponse>> {
        try {
            const request: IDataRequest = {
                url: `/projetos/inversores/${moduloId}/listar`,
                data: body,
            }
            return api.post(request);
        } catch (error) {
            return {
                data: { inversores: []},
                message: "Erro ao buscar inversores",
                statusCode: 404
            }
        }
    }

    async calcularEstrutura(moduloId: number, body: CalcularEstruturaRequest): Promise<IDataResponse<CalcularEstruturaResponse[]>> {
        try {
            const request: IDataRequest = {
                url: `/projetos/estruturas/${moduloId}/calcular`,
                data: body,
            }
            return apiNoLoading.post(request);
        } catch (error) {
            return {
                data: [],
                message: "Erro ao efetuar calculo",
                statusCode: 404
            }
        }
    }

    async calcularAcessorios(moduloId: number, body: CalcularAcessoriosRequest): Promise<IDataResponse<CalculoComponenteResponse[]>> {
        try {
            const request: IDataRequest = {
                url: `/projetos/acessorios/${moduloId}/calcular`,
                data: body,
            }
            return apiNoLoading.post(request);
        } catch (error) {
            return {
                data: [],
                message: "Erro ao efetuar calculo",
                statusCode: 404
            }
        }
    }

    async calcularRoiPayback({ projetoId, calculateData }: CalcularRoiPaybackRequest): Promise<IDataResponse<CalcularRoiPaybackResponse | null>> {
        try {
            if (!projetoId && (!calculateData || Object.keys(calculateData).length === 0)) {
                return {
                    data: null,
                    message: "Erro ao efetuar calculo",
                    statusCode: 404
                }    
            }

            let url = `/projetos/roipayback/calcular`

            if (projetoId) url += `?projeto_id=${projetoId}`

            const request: IDataRequest = {
                url,
                data: calculateData || undefined
            }
            return apiNoLoading.post(request);
        } catch (error) {
            return {
                data: null,
                message: "Erro ao efetuar calculo",
                statusCode: 404
            }
        }
    }

    async calcularCorrenteReversa(moduloId: number, body: CalcularCorrenteReversaRequest): Promise<IDataResponse<CalculoCorrenteReversaResponse>> {
        try {
            const request: IDataRequest = {
                url: `/projetos/corrente_reversa/${moduloId}/calcular`,
                data: body,
            }
            return apiNoLoading.post(request);
        } catch (error) {
            return {
                data: {
                    inversores: [],
                    corrente_reversa: false
                },
                message: "Erro ao efetuar calculo",
                statusCode: 404
            }
        }
    }

    async calcularModulosStrings(moduloId: number, body: CalcularModulosStringRequest): Promise<IDataResponse<CalculoModulosStringResponse>> {
        try {
            const request: IDataRequest = {
                url: `/projetos/modulos_string/${moduloId}/calcular`,
                data: body,
            }
            return apiNoLoading.post(request);
        } catch (error) {
            return {
                data: {
                    divergencia_strings: false
                },
                message: "Erro ao efetuar calculo",
                statusCode: 404
            }
        }
    }

    async enviarEmailProposta(codigoVenda: string, tipo: TipoProposta): Promise<IDataResponse | null> {
        if (!codigoVenda) return null
        const url = `/projetos/propostas/enviar_proposta?codigo_venda=${codigoVenda}&tipo=${tipo}`
        const request: IDataRequest = { url }
        return apiNoLoading.post(request);
    }

    async enviarParaPagamento(request: RequestEnviarPagamento): Promise<IDataResponse> {
        const payload: IDataRequest = {
            url: "/projetos/enviar_pagamento",
            data: request
        }
        return apiNoLoading.post(payload);
    }

    async buscarCarrinhoKits(codigoVenda?: string): Promise<IDataResponse<CarrinhoKitsResponse[] | null>> {
        try {
            const request: IDataRequest = {
                url: `/loja/carrinhos?codigo_venda=${codigoVenda}&includes=itens`,
            }
            return api.get(request);
        } catch (error) {
            return {
                data: null,
                message: "Erro ao efetuar calculo",
                statusCode: 404
            }
        }
    }
    
    async calcularValorMinimoServico(potenciaKw: number, apiInstance = api): Promise<IDataResponse<{ valor_minimo_servico: number } | null>> {
        try {
            const request: IDataRequest = {
                url: `/projetos/valor_minimo_servico/calcular`,
                data: { potencia_kw: potenciaKw }
            }
            return apiInstance.post(request);
        } catch (error) {
            return {
                data: null,
                message: "Erro ao efetuar calculo",
                statusCode: 400
            }
        }
    }
}

export { ProjetosProvider }